


import React from 'react';
import { bauMitigacionExterno, bauReal } from '../pages/Home';
import { Bar }            from 'react-chartjs-2'
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

function Barcompensacion( props ) {
    const [data, setData] = React.useState(null);
    const [options, setOptions] = React.useState(null);
    const [datosListos, setDatosListos] = React.useState(false);
    const datoYears = [];
    const datoBau = [];
    const datoHuella = [];
    const datoCompensa = [];

    const renderChartBar =  () => {
        
        setDatosListos(false);
        console.log(bauMitigacionExterno);
        if (bauMitigacionExterno !== null && bauMitigacionExterno.length > 0) {

            bauMitigacionExterno.map((dato) => {
                Object.entries(dato).map(([key, value]) => {
                    //console.log(key + ' -- '+value);
                    Object.entries(value).map(([key1, value1]) => {
                        //console.log(key1 + ' -- '+value1);
                        if(key === 'mitigacion') {
                            //datoYears.push(key1);
                        }
                    })
                })                

            })
            
            bauReal.map(real => {
                        console.log('year huella real = '+real.year)
                        datoHuella.push(real.bauTotal)
                        datoYears.push(real.year)
                        let equal = false;
                        props.datos.map(com => {
                            if (real.year === com.year) {
                                console.log('year compensa = '+com.year)
                                datoCompensa.push(com.value)
                                equal = true;
                            }
                        })
                        if (!equal) {
                            datoCompensa.push(0);
                        }
            })
  
            console.log('compensa = '+datoCompensa)
            console.log('huella = '+datoHuella)
            console.log('years = '+datoYears)
            
            const dataBauRed = {
                labels: datoYears,
                datasets: [
                {
                    label: "Huella de carbono",
                    lineTension: 0.5,
                    data: datoHuella,
                    fill: false,
                    backgroundColor: "#16558F"
                },
                {
                    label: "Compensación (Kg CO2 eq capturado)",
                    lineTension: 0.5,
                    data: datoCompensa,
                    fill: false,
                    //backgroundColor: "#3EA055"
                    backgroundColor: [
                        '#3EA055',
                        '#006400'
                    ]
                }
                ]
            }
            setData(dataBauRed);
            setDatosListos(true);
        }
        const options = {
            plugins: {
              title: {
                display: true,
                text: 'Compensación (Kg CO2 eq capturado)',
              },
              afterDraw: chart => {
                var ctx = chart.chart.ctx;
                ctx.save();
      
      ctx.textAlign = 'left';
      ctx.font = '18px Arial';
      ctx.fillText('200', chart.chart.width / 2, chart.chart.height - 10);
      ctx.restore();
              }
            },
            responsive: true,
            scales: {
              x: {
                stacked: true,
              },
              y: {
                stacked: true,
              },
            },
        };
        setOptions(options);
    }

    React.useEffect(() => {
        const timer = setTimeout(() => {
            renderChartBar();
            console.log('Enviando actualizar Barchart')
        }, 1000);
        return () => clearTimeout(timer);
    }, [bauReal, props.datos])
    
  
    return (
        <div>
            { (data !== null) ?
                <Bar options={options} data={data}/>
                :
                <img src='/loading.gif'></img>
            }
        </div>
    )
}

export { Barcompensacion };
